module.exports = __webpack_public_path__ + "img/pic-1-1.c1151f0b.png";